import SvgColor from '../../../components/svg-color';

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

export const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
    requirement: {},
  },
  {
    title: 'tickets',
    path: '/dashboard/tickets',
    icon: icon('ic_ticket'),
    requirement: { permission: 'TICKETS:UI_ACCESS' },
  },
  {
    title: 'departments',
    path: '/dashboard/departments',
    icon: icon('ic_department'),
    requirement: { permission: 'DEPARTMENTS:UI_ACCESS' },
  },
  {
    title: 'forms',
    path: '/dashboard/forms',
    icon: icon('ic_form'),
    requirement: { permission: 'FORMS:UI_ACCESS' },
  },
  {
    title: 'Status',
    path: '/dashboard/Status',
    icon: icon('ic_flow'),
    requirement: { permission: 'STATUSES:UI_ACCESS' },
  },
  {
    title: 'tags',
    path: '/dashboard/tags',
    icon: icon('ic_tag'),
    requirement: { permission: 'ATTRIBUTES:UI_ACCESS' },
  },
  {
    title: 'ShareableForms',
    path: '/dashboard/shareableForms',
    icon: icon('ic_shareable_forms'),
    requirement: { permission: 'SHAREABLE_FORMS:UI_ACCESS' },
  },
  {
    title: 'clientCredentials',
    path: '/dashboard/clientCredentials',
    icon: icon('Key_alt'),
    requirement: { permission: 'CLIENT_CREDENTIALS:UI_ACCESS' },
  },
  {
    title: 'MyGroups',
    path: '/dashboard/myGroups',
    icon: icon('my_groups'),
    requirement: { permission: 'MY_GROUPS:UI_ACCESS' },
  },
  {
    title: 'users',
    path: '/dashboard/user',
    icon: icon('ic_user'),
    requirement: { permission: 'USERS:UI_ACCESS' },
  },
  {
    title: 'roles',
    path: '/dashboard/roles',
    icon: icon('ic_roles'),
    requirement: { permission: 'ROLES:UI_ACCESS' },
  },
];
